import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ComingSoonPopupComponent } from '../coming-soon-popup/coming-soon-popup.component';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  ymLogoPng: string;
  public innerWidth: any;
  sideMenuSections: { label: string, items: any[] }[] = [];

  gridItems: { title: string, icon: string, url: string }[] = [
    { title: 'Dashboard', icon: 'space_dashboard', url: '/dashboard' },

    { title: 'AePS', icon: 'fingerprint', url: '/aeps' },
    { title: 'Aadhaar Pay', icon: 'touch_app', url: '/aeps/aadhaar-pay' },
    { title: 'DMT', icon: 'send', url: '/dmt/fino' },
    { title: 'CMS', icon: 'point_of_sale', url: '/cms' },
    { title: 'Airtel CMS', icon: 'storefront', url: '/airtelcms' },
    { title: 'Bank Management', icon: 'account_balance', url: '/bank-management' },
    { title: 'Apply Devices', icon: 'devices_other', url: '/mATM' },

    { title: 'Mobile Recharge', icon: 'smartphone', url: '/recharge' },
    { title: 'DTH Recharge', icon: 'live_tv', url: '/dth-recharge' },
    { title: 'Electricity', icon: 'bolt', url: 'comingsoon' },
    { title: 'Water', icon: 'water_drop', url: 'comingsoon' },
    { title: 'Gas', icon: 'local_fire_department', url: 'comingsoon' },
    { title: 'EMI', icon: 'payments', url: 'comingsoon' },
    { title: 'Fastag', icon: 'toll', url: 'comingsoon' },

    { title: 'Move to Bank', icon: 'savings', url: '/move-to-bank' },
    { title: 'Move to Distributor', icon: 'swap_horiz', url: '/move-to-distributor' },
    { title: 'Recharge Wallet', icon: 'account_balance_wallet', url: '/recharge-wallet' },

    { title: 'Earnings', icon: 'trending_up', url: '/earnings' },
    { title: 'Transactions History', icon: 'history', url: '/history' },
    { title: 'TDS Certificate', icon: 'receipt_long', url: '/tds-certificate' },
    { title: 'My Plans', icon: 'assignment', url: '/my-plans' },
    { title: 'Merchant Certificate', icon: 'verified', url: '/retailer-certificate' },

    { title: 'PAN Service', icon: 'badge', url: '/pan-service' },
    { title: 'Marketing Media', icon: 'campaign', url: '/media-type' },
    { title: 'Useful Links', icon: 'link', url: '/useful-links' },
    { title: 'Complaint', icon: 'support_agent', url: '/complaint' },
    { title: 'Contact Us', icon: 'call', url: '/Contact-Us' },
    { title: 'Biometric Drivers', icon: 'download', url: '/device-configuration-tutorial' },
    { title: 'Notifications', icon: 'notifications', url: '/notifications' }
  ];

  private sideGroupMap: any = {
    'Dashboard': 'Overview',
    'AePS': 'Banking', 'Aadhaar Pay': 'Banking', 'DMT': 'Banking', 'CMS': 'Banking', 'Airtel CMS': 'Banking',
    'Bank Management': 'Banking', 'Apply Devices': 'Banking',
    'Mobile Recharge': 'Recharges & Bills', 'DTH Recharge': 'Recharges & Bills', 'Electricity': 'Recharges & Bills',
    'Water': 'Recharges & Bills', 'Gas': 'Recharges & Bills', 'EMI': 'Recharges & Bills', 'Fastag': 'Recharges & Bills',
    'Move to Bank': 'Wallet', 'Move to Distributor': 'Wallet', 'Recharge Wallet': 'Wallet',
    'Earnings': 'Reports', 'Transactions History': 'Reports', 'TDS Certificate': 'Reports',
    'My Plans': 'Reports', 'Merchant Certificate': 'Reports',
    'PAN Service': 'Tools & Support', 'Marketing Media': 'Tools & Support', 'Useful Links': 'Tools & Support',
    'Complaint': 'Tools & Support', 'Contact Us': 'Tools & Support', 'Biometric Drivers': 'Tools & Support',
    'Notifications': 'Tools & Support'
  };

  constructor(private authService: AuthService, private dialog: MatDialog) {
    this.ymLogoPng = environment.ym_logo_png;
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.buildSideMenu();
  }

  buildSideMenu() {
    const order = ['Overview', 'Banking', 'Recharges & Bills', 'Wallet', 'Reports', 'Tools & Support'];
    const sections: any = {};
    this.gridItems.forEach(it => {
      const group = this.sideGroupMap[it.title] || 'Tools & Support';
      if (!sections[group]) { sections[group] = []; }
      sections[group].push(it);
    });
    this.sideMenuSections = order.filter(l => sections[l]).map(l => ({ label: l, items: sections[l] }));
  }

  openPopup() {
    this.dialog.open(ComingSoonPopupComponent, { width: '420px' });
  }
}
